import { createReducer, INITIAL_STATE } from '../../../shared/redux';
import { getErrorKey, LOAD_STATE } from '../../../shared/axios';

import {
    buildGetBillingDetailsApiConfig,
    buildPostBillingDetailsApiConfig,
    buildEditBillingDetailsApiConfig,
} from './billing-details.api';

export const GET_BILLING_DETAILS_REQUEST_CALLED = '@billing/details/GET_BILLING_DETAILS_REQUEST_CALLED';
export const GET_BILLING_DETAILS_REQUEST_SUCCEEDED = '@billing/details/GET_BILLING_DETAILS_REQUEST_SUCCEEDED';
export const GET_BILLING_DETAILS_REQUEST_FAILED = '@billing/details/GET_BILLING_DETAILS_REQUEST_FAILED';

export const POST_BILLING_DETAILS_REQUEST_CALLED = '@billing/details/POST_BILLING_DETAILS_REQUEST_CALLED';
export const POST_BILLING_DETAILS_REQUEST_SUCCEEDED = '@billing/details/POST_BILLING_DETAILS_REQUEST_SUCCEEDED';
export const POST_BILLING_DETAILS_REQUEST_FAILED = '@billing/details/POST_BILLING_DETAILS_REQUEST_FAILED';

export const EDIT_BILLING_DETAILS_REQUEST_CALLED = '@billing/details/EDIT_BILLING_DETAILS_REQUEST_CALLED';
export const EDIT_BILLING_DETAILS_REQUEST_SUCCEEDED = '@billing/details/EDIT_BILLING_DETAILS_REQUEST_SUCCEEDED';
export const EDIT_BILLING_DETAILS_REQUEST_FAILED = '@billing/details/EDIT_BILLING_DETAILS_REQUEST_FAILED';

export const SUBMIT_BILLING_DETAILS = '@billing/details/SUBMIT_BILLING_DETAILS';

export const SET_BILLING_DETAILS_VALIDATION_ERROS = '@billing/details/SET_BILLING_DETAILS_VALIDATION_ERROS';

export const getBillingDetails = state => state.billing.details.data;
export const getBillingDetailsLoadState = state => state.billing.details.loadState;
export const getBillingDetailsRequestLoadState = state => state.billing.details.getLoadState;
export const getBillingDetailsErros = state => state.billing.details.validationErros;

export const getBillingDetailsRequest = () => ({
    type: GET_BILLING_DETAILS_REQUEST_CALLED,
    actionTypes: {
        success: GET_BILLING_DETAILS_REQUEST_SUCCEEDED,
        fail: GET_BILLING_DETAILS_REQUEST_FAILED,
    },
    config: buildGetBillingDetailsApiConfig(),
});

export const postBillingDetailsRequest = ({ data }) => ({
    type: POST_BILLING_DETAILS_REQUEST_CALLED,
    actionTypes: {
        success: POST_BILLING_DETAILS_REQUEST_SUCCEEDED,
        fail: POST_BILLING_DETAILS_REQUEST_FAILED,
    },
    config: buildPostBillingDetailsApiConfig({ data }),
});

export const editBillingDetailsRequest = ({ data }) => ({
    type: EDIT_BILLING_DETAILS_REQUEST_CALLED,
    actionTypes: {
        success: EDIT_BILLING_DETAILS_REQUEST_SUCCEEDED,
        fail: EDIT_BILLING_DETAILS_REQUEST_FAILED,
    },
    config: buildEditBillingDetailsApiConfig({ data }),
});

export const submitBillingDetails = data => ({
    type: SUBMIT_BILLING_DETAILS,
    payload: {
        data,
    },
});


export const setBillingDetailsErros = erros => ({
    type: SET_BILLING_DETAILS_VALIDATION_ERROS,
    payload: {
        erros,
    },
});

const initialState = {
    getLoadState: LOAD_STATE.LOADING,
    loadState: LOAD_STATE.SUCCESS,
    data: {
        street: '',
        number: '',
        cep: '',
        cnpj: '',
        city: '',
        cityCode: '',
        countryCode: '',
        district: '',
        email: '',
        id: '',
        phoneNumber: '',
        state: '',
        stateCode: '',
        taxNumber: '',
        zipCode: '',
    },
    error: null,
    validationErros: {
        street: null,
        number: null,
        cep: null,
        cnpj: null,
        city: null,
        countryCode: null,
        district: null,
        email: null,
        id: null,
        phoneNumber: null,
        state: null,
        stateCode: '',
        taxNumber: null,
        zipCode: null,
    },
};

export const billingDetailsReducers = createReducer({
    [INITIAL_STATE]: initialState,
    [GET_BILLING_DETAILS_REQUEST_CALLED]: () => ({
        ...initialState,
    }),
    [GET_BILLING_DETAILS_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        getLoadState: LOAD_STATE.SUCCESS,
        data: action.payload.data,
    }),
    [GET_BILLING_DETAILS_REQUEST_FAILED]: (state, action) => ({
        ...state,
        getLoadState: LOAD_STATE.FAIL,
        error: getErrorKey(action),
    }),
    [POST_BILLING_DETAILS_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
    }),
    [POST_BILLING_DETAILS_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.SUCCESS,
        data: action.payload.data,
    }),
    [POST_BILLING_DETAILS_REQUEST_FAILED]: state => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
    }),
    [EDIT_BILLING_DETAILS_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
    }),
    [EDIT_BILLING_DETAILS_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.SUCCESS,
        data: action.payload.data,
    }),
    [EDIT_BILLING_DETAILS_REQUEST_FAILED]: state => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
    }),
    [SET_BILLING_DETAILS_VALIDATION_ERROS]: (state, action) => ({
        ...state,
        validationErros: action.payload.erros,
    }),
});
